/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type TaskEvaluationConfigInputFormalCriteriaSource =
  (typeof TaskEvaluationConfigInputFormalCriteriaSource)[keyof typeof TaskEvaluationConfigInputFormalCriteriaSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaskEvaluationConfigInputFormalCriteriaSource = {
  default: 'default',
  task_params: 'task_params',
  rubric: 'rubric',
} as const;
